<template>
  <span
    class="banner-status-badge"
    :style="{ backgroundColor: config.badgeColor }"
  >
    {{ config.label }}
  </span>
</template>

<script>
import { getStatusConfig } from "../helpers/bannerStatus";

export default {
  name: "BannerStatusBadge",
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
  computed: {
    config() {
      return getStatusConfig(this.banner);
    },
  },
};
</script>

<style scoped>
.banner-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  line-height: 1.4;
}
</style>
